import axios from "axios";

export const getClients = () => {
  return axios.get(`${process.env.VUE_APP_API_URL}/clients`);
};
